/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import moment from 'moment';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import suppressNavigation, {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import { ContractsTabelHeader } from './ContractsTableHeader';
import { contractsGridLabel, errorTypeNoData } from './ConstantData';

import {
  STATUS_MSG,
  SUCCESS_MSG,
  NO_DATA_TO_DISPLAY,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  getLabelerDifferencesContract,
  dispatchErrorMessageData,
} from '../store/actions';
import { redirectURLLink } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  dispatchCellClick,
  selectedType,
} from '../../../Maintain/Contract/store/actions';

const Contracts = (props) => {
  const { fullScreenView, handleFullScreenView } = props;
  const [contractDifferences, setContractDifferences] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const getContarctDifferences = useSelector(
    (state) => state.sharedState.LabelerDifferencesReducer.contractDifferences
  );
  const searchContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.searchContractState
  );
  const getMfgId = useSelector((state) => {
    return state.sharedState.LabelerDifferencesReducer.mfgId;
  });
  const getErrorMsg = useSelector(
    (state) => state.sharedState.LabelerDifferencesReducer.errorMessageInRedux
  );
  useEffect(() => {
    const arr = getErrorMsg || [];
    let list = [];
    if (
      getContarctDifferences &&
      getContarctDifferences.status === STATUS_MSG &&
      getContarctDifferences.message === SUCCESS_MSG
    ) {
      if (
        !_.isEmpty(getContarctDifferences.labelerDifferencesContractResponseVO)
      ) {
        list = _.map(
          getContarctDifferences.labelerDifferencesContractResponseVO,
          (val, ind) => ({
            ...val,
            contractSeqNum: val.contractSeqNum,
            contractName: val.contractName,
            contactTypeCd: val.contactTypeCd,
          })
        );
      }
    }
    setContractDifferences(list);
  }, [getContarctDifferences]);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  // go to particular Contract action button handler function
  const handleGoToContract = (row) => {
    dispatch(dispatchCellClick(true));
    dispatch(selectedType('C'));
    searchContractState.contractType = 'onSelect';
    searchContractState.selectedContractType = 'contractId';
    searchContractState.searchContractDate = moment(row?.startDt).format(
      'MM/DD/YYYY'
    );
    searchContractState.selectedRowData = row?.contractSeqNum;
    searchContractState.selectedContractId = row?.contractSeqNum;
    searchContractState.rebateProgramCode = row?.rebateProgramCd;
    redirectURLLink('/createContract', 'Maintain Contract', history, dispatch);
  };
  return (
    <div className="row">
      <div className="col-sm-12">
        <TableGridWithFeatures
          data-testid="labeler-diffrences-contracts-grid"
          rowSelection="single"
          rowMultiSelectWithClick={false}
          fullScreenView={fullScreenView}
          handleFullScreenViewClick={handleFullScreenView}
          gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
          gridCall={onGridReady}
          columnDefs={ContractsTabelHeader}
          rowData={contractDifferences}
          exportFile
          animateRows
          sideBar={false}
          fileName={contractsGridLabel}
          navigateToNextCell={navigateToNextCell}
          tabToNextCell={tabToNextCell}
          enterMovesDown
          suppressCellFocus
          onCellFocused={onCellFocused}
          onFilterData={false}
          frameworkComponents={{
            ContractIdRenderer: (cellInfo) => {
              const [hoverUnder, setHoverUnder] = React.useState(false);
              return (
                <div
                  className={hoverUnder ? 'frr-text-decoration-underline' : ''}
                  style={{ textAlign: 'right' }}
                >
                  <Link
                    to="#"
                    role="button"
                    onClick={() => {
                      handleGoToContract(cellInfo?.data);
                    }}
                    onMouseOver={() => {
                      setHoverUnder(true);
                    }}
                    onMouseOut={() => {
                      setHoverUnder(false);
                    }}
                  >
                    {cellInfo && cellInfo.value}
                  </Link>
                </div>
              );
            },
            ContractNameRenderer: (cellInfo) => {
              if (
                cellInfo.value !== null &&
                cellInfo.value !== '' &&
                cellInfo.value.length > 45
              ) {
                return (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="labeler-tooltip">{cellInfo.value}</Tooltip>
                    }
                  >
                    <div>{cellInfo.value}</div>
                  </OverlayTrigger>
                );
              }
              return <div>{cellInfo.value}</div>;
            },
          }}
        />
      </div>
    </div>
  );
};

export default Contracts;
